// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { startOfWeekYear as fn } from "../startOfWeekYear.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const startOfWeekYear = convertToFP(fn, 1);

// Fallback for modularized imports:
export default startOfWeekYear;
